'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * RF Server API
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * this is the API for the RF server
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * The version of the OpenAPI document: 1.0.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Contact: bryan@dau.it
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * https://openapi-generator.tech
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Do not edit the class manually.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

var _ApiClient = require('../ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _AuthorizationServer = require('../model/AuthorizationServer');

var _AuthorizationServer2 = _interopRequireDefault(_AuthorizationServer);

var _AuthorizationServerError = require('../model/AuthorizationServerError');

var _AuthorizationServerError2 = _interopRequireDefault(_AuthorizationServerError);

var _ErrorResponse = require('../model/ErrorResponse');

var _ErrorResponse2 = _interopRequireDefault(_ErrorResponse);

var _User = require('../model/User');

var _User2 = _interopRequireDefault(_User);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
* User service.
* @module /api/UserApi
* @version 1.0.0
*/
var UserApi = function () {

  /**
  * Constructs a new UserApi. 
  * @alias module:/api/UserApi
  * @class
  * @param {module:/ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:/ApiClient#instance} if unspecified.
  */
  function UserApi(apiClient) {
    _classCallCheck(this, UserApi);

    this.apiClient = apiClient || _ApiClient2.default.instance;
  }

  /**
   * Callback function to receive the result of the userDeleteImageDelete operation.
   * @callback module:/api/UserApi~userDeleteImageDeleteCallback
   * @param {String} error Error message, if any.
   * @param data This operation does not return a value.
   * @param {String} response The complete HTTP response.
   */

  /**
   * delete the current user image
   * @param {String} authorization pass the access token
   * @param {module:/api/UserApi~userDeleteImageDeleteCallback} callback The callback function, accepting three arguments: error, data, response
   */


  _createClass(UserApi, [{
    key: 'userDeleteImageDelete',
    value: function userDeleteImageDelete(authorization, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userDeleteImageDelete");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user/deleteImage', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userGet operation.
     * @callback module:/api/UserApi~userGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/User} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get the user info
     * @param {String} authorization pass the access token
     * @param {module:/api/UserApi~userGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/User}
     */

  }, {
    key: 'userGet',
    value: function userGet(authorization, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userGet");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _User2.default;
      return this.apiClient.callApi('/user', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userLogoutGet operation.
     * @callback module:/api/UserApi~userLogoutGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * logout from the website
     * With this method you can delete the cookie setted on the client, in order to definetly logout from the website. 
     * @param {module:/api/UserApi~userLogoutGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'userLogoutGet',
    value: function userLogoutGet(callback) {
      var postBody = null;

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/user/logout', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userNameCustomRegistrationPost operation.
     * @callback module:/api/UserApi~userNameCustomRegistrationPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add a new User
     * @param {String} tokenNext used to pass the token obtained from a next server.
     * @param {module:model/User} user used to pass the token obtained from a next server.
     * @param {module:/api/UserApi~userNameCustomRegistrationPostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'userNameCustomRegistrationPost',
    value: function userNameCustomRegistrationPost(tokenNext, user, callback) {
      var postBody = user;
      // verify the required parameter 'tokenNext' is set
      if (tokenNext === undefined || tokenNext === null) {
        throw new Error("Missing the required parameter 'tokenNext' when calling userNameCustomRegistrationPost");
      }
      // verify the required parameter 'user' is set
      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling userNameCustomRegistrationPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'TokenNext': tokenNext
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user/name:CustomRegistration', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userNameRSALoginPost operation.
     * @callback module:/api/UserApi~userNameRSALoginPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * accept the login always as valide since it is made with RSA, if the user doesn't existing it creates it immediatly
     * @param {String} tokenNext used to pass the token obtained from a next server.
     * @param {module:model/User} user used to pass the token obtained from a next server.
     * @param {module:/api/UserApi~userNameRSALoginPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'userNameRSALoginPost',
    value: function userNameRSALoginPost(tokenNext, user, callback) {
      var postBody = user;
      // verify the required parameter 'tokenNext' is set
      if (tokenNext === undefined || tokenNext === null) {
        throw new Error("Missing the required parameter 'tokenNext' when calling userNameRSALoginPost");
      }
      // verify the required parameter 'user' is set
      if (user === undefined || user === null) {
        throw new Error("Missing the required parameter 'user' when calling userNameRSALoginPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'TokenNext': tokenNext
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/user/name:RSALogin', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userOauth2Get operation.
     * @callback module:/api/UserApi~userOauth2GetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * login into the server
     * This method respect the **OAuth2.0 Standard** 
     * @param {String} authorizationCode pass the code of the authorization
     * @param {module:/api/UserApi~userOauth2GetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'userOauth2Get',
    value: function userOauth2Get(authorizationCode, callback) {
      var postBody = null;
      // verify the required parameter 'authorizationCode' is set
      if (authorizationCode === undefined || authorizationCode === null) {
        throw new Error("Missing the required parameter 'authorizationCode' when calling userOauth2Get");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'authorization_code': authorizationCode
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/user/oauth2', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userPost operation.
     * @callback module:/api/UserApi~userPostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * insert a user
     * @param {String} authorization use to pass the token request obtained from the Invitation email
     * @param {module:model/User} body User object to add in the DB
     * @param {module:/api/UserApi~userPostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'userPost',
    value: function userPost(authorization, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userPost");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling userPost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userRefreshAccessTokenGet operation.
     * @callback module:/api/UserApi~userRefreshAccessTokenGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AuthorizationServer} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * refresh an expired access token.
     * This method respect the **OAuth2.0 Standard**, and it is used to obtain a new access token when it is expired. Use this methods only if you have signed keep me log in, and you have the cookie setted. 
     * @param {Object} opts Optional parameters
     * @param {String} opts.refreshToken if it is included it overtwrites the cookie refresh_token
     * @param {module:/api/UserApi~userRefreshAccessTokenGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AuthorizationServer}
     */

  }, {
    key: 'userRefreshAccessTokenGet',
    value: function userRefreshAccessTokenGet(opts, callback) {
      opts = opts || {};
      var postBody = null;

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'refresh_token': opts['refreshToken']
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AuthorizationServer2.default;
      return this.apiClient.callApi('/user/refreshAccessToken', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userRetrieveUserImageGet operation.
     * @callback module:/api/UserApi~userRetrieveUserImageGetCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * retrieve the image
     * @param {String} authorization pass the access token
     * @param {module:/api/UserApi~userRetrieveUserImageGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */

  }, {
    key: 'userRetrieveUserImageGet',
    value: function userRetrieveUserImageGet(authorization, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userRetrieveUserImageGet");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['image/jpg', 'image/png', 'image/gif'];
      var returnType = 'Blob';
      return this.apiClient.callApi('/user/retrieveUserImage', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userUploadImagePost operation.
     * @callback module:/api/UserApi~userUploadImagePostCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * upload the user image
     * @param {String} authorization pass the access token
     * @param {Object} opts Optional parameters
     * @param {File} opts.file The image to be uploaded.
     * @param {module:/api/UserApi~userUploadImagePostCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'userUploadImagePost',
    value: function userUploadImagePost(authorization, opts, callback) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userUploadImagePost");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'authorization': authorization
      };
      var formParams = {
        'file': opts['file']
      };

      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user/uploadImage', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userUseremailDelete operation.
     * @callback module:/api/UserApi~userUseremailDeleteCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete a user
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} useremail use to pass the useremail of who you are trying to get the information
     * @param {module:/api/UserApi~userUseremailDeleteCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'userUseremailDelete',
    value: function userUseremailDelete(authorization, useremail, callback) {
      var postBody = null;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userUseremailDelete");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling userUseremailDelete");
      }

      var pathParams = {
        'useremail': useremail
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user/{useremail}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }

    /**
     * Callback function to receive the result of the userUseremailPut operation.
     * @callback module:/api/UserApi~userUseremailPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * modify a user
     * @param {String} authorization use to pass the access token obtained from a login
     * @param {String} useremail use to pass the useremail of who you are trying to get the information
     * @param {module:model/User} body User object to add in the DB
     * @param {module:/api/UserApi~userUseremailPutCallback} callback The callback function, accepting three arguments: error, data, response
     */

  }, {
    key: 'userUseremailPut',
    value: function userUseremailPut(authorization, useremail, body, callback) {
      var postBody = body;
      // verify the required parameter 'authorization' is set
      if (authorization === undefined || authorization === null) {
        throw new Error("Missing the required parameter 'authorization' when calling userUseremailPut");
      }
      // verify the required parameter 'useremail' is set
      if (useremail === undefined || useremail === null) {
        throw new Error("Missing the required parameter 'useremail' when calling userUseremailPut");
      }
      // verify the required parameter 'body' is set
      if (body === undefined || body === null) {
        throw new Error("Missing the required parameter 'body' when calling userUseremailPut");
      }

      var pathParams = {
        'useremail': useremail
      };
      var queryParams = {};
      var headerParams = {
        'Authorization': authorization
      };
      var formParams = {};

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/user/{useremail}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null, callback);
    }
  }]);

  return UserApi;
}();

exports.default = UserApi;
//# sourceMappingURL=UserApi.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/renderfarmapi/lib/lib-commonjs/api/UserApi.js
// module id = 563
// module chunks = 142